// Define all major ports/locations
export const PORTS = {
  Shanghai: {
    name: "Shanghai, China",
    coordinates: { lat: 31.2304, lng: 121.4737 },
  },
  Tokyo: {
    name: "Tokyo, Japan",
    coordinates: { lat: 35.6762, lng: 139.6503 },
  },
  Singapore: {
    name: "Singapore",
    coordinates: { lat: 1.3521, lng: 103.8198 },
  },
  Mumbai: {
    name: "Mumbai, India",
    coordinates: { lat: 19.076, lng: 72.8777 },
  },
  Rotterdam: {
    name: "Rotterdam, Netherlands",
    coordinates: { lat: 51.9225, lng: 4.4792 },
  },
  Hamburg: {
    name: "Hamburg, Germany",
    coordinates: { lat: 53.5511, lng: 9.9937 },
  },
  Southampton: {
    name: "Southampton, UK",
    coordinates: { lat: 50.9097, lng: -1.4044 },
  },
  LeHavre: {
    name: "Le Havre, France",
    coordinates: { lat: 49.4944, lng: 0.1079 },
  },
  NewYork: {
    name: "New York, USA",
    coordinates: { lat: 40.7128, lng: -74.006 },
  },
  Dubai: {
    name: "Dubai, UAE",
    coordinates: { lat: 25.2048, lng: 55.2708 },
  },
  Busan: {
    name: "Busan, South Korea",
    coordinates: { lat: 35.1796, lng: 129.0756 },
  },
  Santos: {
    name: "Santos, Brazil",
    coordinates: { lat: -23.9618, lng: -46.3322 },
  },
  Antwerp: {
    name: "Antwerp, Belgium",
    coordinates: { lat: 51.2195, lng: 4.4024 },
  },
  Vancouver: {
    name: "Vancouver, Canada",
    coordinates: { lat: 49.2827, lng: -123.1207 },
  },
  Melbourne: {
    name: "Melbourne, Australia",
    coordinates: { lat: -37.8136, lng: 144.9631 },
  },
  Piraeus: {
    name: "Piraeus, Greece",
    coordinates: { lat: 37.9422, lng: 23.6466 },
  },
  Jeddah: {
    name: "Jeddah, Saudi Arabia",
    coordinates: { lat: 21.5433, lng: 39.1728 },
  },
  CapeTown: {
    name: "Cape Town, South Africa",
    coordinates: { lat: -33.918, lng: 18.4233 },
  },
  Colombo: {
    name: "Colombo, Sri Lanka",
    coordinates: { lat: 6.9271, lng: 79.8612 },
  },
  Barcelona: {
    name: "Barcelona, Spain",
    coordinates: { lat: 41.3851, lng: 2.1734 },
  },
  Marseille: {
    name: "Marseille, France",
    coordinates: { lat: 43.2965, lng: 5.3698 },
  },
  Alexandria: {
    name: "Alexandria, Egypt",
    coordinates: { lat: 31.2001, lng: 29.9187 },
  },
  HoChiMinh: {
    name: "Ho Chi Minh City, Vietnam",
    coordinates: { lat: 10.8231, lng: 106.6297 },
  },
  Manila: {
    name: "Manila, Philippines",
    coordinates: { lat: 14.5995, lng: 120.9842 },
  },
  Jakarta: {
    name: "Jakarta, Indonesia",
    coordinates: { lat: -6.2088, lng: 106.8456 },
  },
  Valparaiso: {
    name: "Valparaíso, Chile",
    coordinates: { lat: -33.0472, lng: -71.6127 },
  },
  Durban: {
    name: "Durban, South Africa",
    coordinates: { lat: -29.8587, lng: 31.0218 },
  },
  Lagos: {
    name: "Lagos, Nigeria",
    coordinates: { lat: 6.4541, lng: 3.3947 },
  },
  Karachi: {
    name: "Karachi, Pakistan",
    coordinates: { lat: 24.8607, lng: 67.0011 },
  },
  // ... add other ports as needed
};

// Define shipping routes between ports
export const SHIPPING_ROUTES = {
  "Shanghai-Hamburg": {
    from: PORTS.Shanghai,
    to: PORTS.Hamburg,
    waypoints: [
      PORTS.Shanghai.coordinates,
      { lat: 31.0, lng: 122.5 }, // Yangtze River mouth
      { lat: 25.0, lng: 120.0 }, // Taiwan Strait
      { lat: 20.0, lng: 118.0 }, // South China Sea
      { lat: 10.0, lng: 107.0 }, // Vietnam Coast
      { lat: 6.9271, lng: 98.0 }, // Malacca Strait
      { lat: 6.0, lng: 80.0 }, // Sri Lanka
      { lat: 12.0, lng: 45.0 }, // Gulf of Aden
      { lat: 27.0, lng: 34.0 }, // Suez Canal
      { lat: 36.0, lng: 3.0 }, // Mediterranean
      { lat: 36.0, lng: -5.0 }, // Gibraltar Strait
      { lat: 44.0, lng: -8.0 }, // Bay of Biscay
      { lat: 50.0, lng: 0.0 }, // English Channel
      { lat: 51.5, lng: 3.0 }, // North Sea
      { lat: 53.9, lng: 8.0 }, // Elbe River approach
      PORTS.Hamburg.coordinates,
    ],
  },

  "Shanghai-NewYork": {
    from: PORTS.Shanghai,
    to: PORTS.NewYork,
    waypoints: [
      PORTS.Shanghai.coordinates,
      { lat: 25.0, lng: 125.0 }, // East China Sea
      { lat: 35.0, lng: 165.0 }, // North Pacific
      { lat: 40.0, lng: -160.0 }, // Mid Pacific
      { lat: 35.0, lng: -122.0 }, // US West Coast
      { lat: 22.0, lng: -98.0 }, // Panama Canal North
      { lat: 20.0, lng: -75.0 }, // Caribbean Sea
      { lat: 25.0, lng: -73.0 }, // Bahamas
      PORTS.NewYork.coordinates,
    ],
  },

  "Mumbai-Singapore": {
    from: PORTS.Mumbai,
    to: PORTS.Singapore,
    waypoints: [
      PORTS.Mumbai.coordinates,
      { lat: 18.9, lng: 72.9 }, // Mumbai harbor exit
      { lat: 8.0, lng: 75.0 }, // Kerala Coast
      { lat: 5.0, lng: 80.0 }, // South of Sri Lanka
      { lat: 6.0, lng: 90.0 }, // Andaman Sea
      { lat: 3.0, lng: 98.0 }, // Malacca Strait
      { lat: 1.5, lng: 103.7 }, // Singapore approach
      PORTS.Singapore.coordinates,
    ],
  },

  "Rotterdam-NewYork": {
    from: PORTS.Rotterdam,
    to: PORTS.NewYork,
    waypoints: [
      PORTS.Rotterdam.coordinates,
      { lat: 52.0, lng: 4.0 }, // Rotterdam exit
      { lat: 51.5, lng: 3.0 }, // North Sea
      { lat: 51.0, lng: 1.5 }, // English Channel
      { lat: 48.0, lng: -5.0 }, // Bay of Biscay
      { lat: 42.0, lng: -20.0 }, // North Atlantic
      { lat: 40.0, lng: -50.0 }, // Mid Atlantic
      { lat: 40.5, lng: -73.8 }, // New York approach
      PORTS.NewYork.coordinates,
    ],
  },

  "Tokyo-Singapore": {
    from: PORTS.Tokyo,
    to: PORTS.Singapore,
    waypoints: [
      PORTS.Tokyo.coordinates,
      { lat: 35.0, lng: 140.0 }, // Tokyo Bay exit
      { lat: 30.0, lng: 132.0 }, // South of Japan
      { lat: 25.0, lng: 125.0 }, // East China Sea
      { lat: 20.0, lng: 120.0 }, // Taiwan east coast
      { lat: 15.0, lng: 115.0 }, // South China Sea
      { lat: 10.0, lng: 109.0 }, // Vietnam coast
      { lat: 5.0, lng: 105.0 }, // South China Sea
      { lat: 1.5, lng: 103.7 }, // Singapore approach
      PORTS.Singapore.coordinates,
    ],
  },

  "Southampton-LeHavre": {
    from: PORTS.Southampton,
    to: PORTS.LeHavre,
    waypoints: [
      PORTS.Southampton.coordinates,
      { lat: 50.7, lng: -1.5 }, // Solent exit
      { lat: 50.5, lng: -1.0 }, // English Channel
      { lat: 50.2, lng: 0.0 }, // Mid-Channel
      { lat: 49.8, lng: 0.05 }, // Le Havre approach
      PORTS.LeHavre.coordinates,
    ],
  },

  "Rotterdam-Southampton": {
    from: PORTS.Rotterdam,
    to: PORTS.Southampton,
    waypoints: [
      PORTS.Rotterdam.coordinates,
      { lat: 52.0, lng: 4.0 }, // Rotterdam approach
      { lat: 51.5, lng: 3.0 }, // North Sea
      { lat: 51.2, lng: 2.0 }, // Belgian coast
      { lat: 50.9, lng: 1.4 }, // Dover Strait
      { lat: 50.7, lng: 0.5 }, // English Channel
      { lat: 50.6, lng: -0.5 }, // Mid-Channel
      { lat: 50.7, lng: -1.0 }, // Solent approach
      PORTS.Southampton.coordinates,
    ],
  },

  "Dubai-Singapore": {
    from: PORTS.Dubai,
    to: PORTS.Singapore,
    waypoints: [
      PORTS.Dubai.coordinates,
      { lat: 24.0, lng: 58.0 }, // Gulf of Oman
      { lat: 20.0, lng: 63.0 }, // Arabian Sea
      { lat: 12.0, lng: 74.0 }, // Off Indian coast
      { lat: 6.9271, lng: 79.8612 }, // Colombo passage
      { lat: 5.0, lng: 90.0 }, // Andaman Sea
      { lat: 3.0, lng: 98.0 }, // Malacca Strait
      PORTS.Singapore.coordinates,
    ],
  },

  "Busan-Vancouver": {
    from: PORTS.Busan,
    to: PORTS.Vancouver,
    waypoints: [
      PORTS.Busan.coordinates,
      { lat: 37.0, lng: 135.0 }, // Sea of Japan
      { lat: 40.0, lng: 150.0 }, // North Pacific
      { lat: 45.0, lng: -170.0 }, // Aleutian route
      { lat: 48.0, lng: -140.0 }, // Gulf of Alaska
      { lat: 49.0, lng: -127.0 }, // Vancouver Island
      PORTS.Vancouver.coordinates,
    ],
  },

  "Santos-CapeTown": {
    from: PORTS.Santos,
    to: PORTS.CapeTown,
    waypoints: [
      PORTS.Santos.coordinates,
      { lat: -25.0, lng: -45.0 }, // Brazilian coast
      { lat: -30.0, lng: -40.0 }, // South Atlantic
      { lat: -33.0, lng: -20.0 }, // Mid-Atlantic
      { lat: -34.0, lng: 0.0 }, // Approaching Africa
      { lat: -34.0, lng: 15.0 }, // South African coast
      PORTS.CapeTown.coordinates,
    ],
  },

  "Antwerp-Piraeus": {
    from: PORTS.Antwerp,
    to: PORTS.Piraeus,
    waypoints: [
      PORTS.Antwerp.coordinates,
      { lat: 51.0, lng: 2.0 }, // English Channel
      { lat: 48.0, lng: -5.0 }, // Bay of Biscay
      { lat: 43.0, lng: -9.0 }, // Off Portuguese coast
      { lat: 36.0, lng: -5.0 }, // Gibraltar Strait
      { lat: 37.0, lng: 5.0 }, // Mediterranean
      { lat: 37.5, lng: 15.0 }, // South of Italy
      PORTS.Piraeus.coordinates,
    ],
  },

  "Melbourne-Singapore": {
    from: PORTS.Melbourne,
    to: PORTS.Singapore,
    waypoints: [
      PORTS.Melbourne.coordinates,
      { lat: -35.0, lng: 145.0 }, // Bass Strait
      { lat: -25.0, lng: 150.0 }, // Coral Sea
      { lat: -10.0, lng: 140.0 }, // Arafura Sea
      { lat: -5.0, lng: 130.0 }, // Banda Sea
      { lat: 0.0, lng: 110.0 }, // Java Sea
      { lat: 1.0, lng: 105.0 }, // Singapore Strait
      PORTS.Singapore.coordinates,
    ],
  },

  "Jeddah-Mumbai": {
    from: PORTS.Jeddah,
    to: PORTS.Mumbai,
    waypoints: [
      PORTS.Jeddah.coordinates,
      { lat: 15.0, lng: 42.0 }, // Red Sea
      { lat: 12.0, lng: 45.0 }, // Gulf of Aden
      { lat: 14.0, lng: 50.0 }, // Arabian Sea
      { lat: 16.0, lng: 60.0 }, // Mid-Arabian Sea
      { lat: 18.0, lng: 70.0 }, // Approaching Mumbai
      PORTS.Mumbai.coordinates,
    ],
  },

  "Colombo-Dubai": {
    from: PORTS.Colombo,
    to: PORTS.Dubai,
    waypoints: [
      PORTS.Colombo.coordinates,
      { lat: 8.0, lng: 75.0 }, // Off Kerala coast
      { lat: 12.0, lng: 70.0 }, // Arabian Sea
      { lat: 16.0, lng: 65.0 }, // Mid-Arabian Sea
      { lat: 20.0, lng: 60.0 }, // Approaching Gulf
      { lat: 24.0, lng: 58.0 }, // Gulf of Oman
      PORTS.Dubai.coordinates,
    ],
  },

  "Vancouver-Tokyo": {
    from: PORTS.Vancouver,
    to: PORTS.Tokyo,
    waypoints: [
      PORTS.Vancouver.coordinates,
      { lat: 48.0, lng: -127.0 }, // Vancouver Island
      { lat: 45.0, lng: -140.0 }, // North Pacific
      { lat: 42.0, lng: -160.0 }, // Mid-Pacific
      { lat: 38.0, lng: 180.0 }, // International Date Line
      { lat: 35.0, lng: 150.0 }, // Approaching Japan
      PORTS.Tokyo.coordinates,
    ],
  },

  "CapeTown-Piraeus": {
    from: PORTS.CapeTown,
    to: PORTS.Piraeus,
    waypoints: [
      PORTS.CapeTown.coordinates,
      { lat: -30.0, lng: 25.0 }, // Off South African coast
      { lat: -20.0, lng: 40.0 }, // Mozambique Channel
      { lat: -5.0, lng: 50.0 }, // Indian Ocean
      { lat: 12.0, lng: 45.0 }, // Gulf of Aden
      { lat: 27.0, lng: 34.0 }, // Suez Canal
      { lat: 35.0, lng: 20.0 }, // Mediterranean
      PORTS.Piraeus.coordinates,
    ],
  },

  "Antwerp-Santos": {
    from: PORTS.Antwerp,
    to: PORTS.Santos,
    waypoints: [
      PORTS.Antwerp.coordinates,
      { lat: 48.0, lng: -5.0 }, // Bay of Biscay
      { lat: 35.0, lng: -12.0 }, // Off African coast
      { lat: 10.0, lng: -25.0 }, // Mid-Atlantic
      { lat: -10.0, lng: -35.0 }, // South Atlantic
      { lat: -20.0, lng: -40.0 }, // Approaching Brazil
      PORTS.Santos.coordinates,
    ],
  },

  "Barcelona-Alexandria": {
    from: PORTS.Barcelona,
    to: PORTS.Alexandria,
    waypoints: [
      PORTS.Barcelona.coordinates,
      { lat: 40.0, lng: 5.0 }, // Balearic Sea
      { lat: 38.0, lng: 12.0 }, // South of Sicily
      { lat: 35.0, lng: 20.0 }, // Mediterranean
      { lat: 32.0, lng: 25.0 }, // Approaching Egypt
      PORTS.Alexandria.coordinates,
    ],
  },

  "Manila-HoChiMinh": {
    from: PORTS.Manila,
    to: PORTS.HoChiMinh,
    waypoints: [
      PORTS.Manila.coordinates,
      { lat: 14.0, lng: 118.0 }, // South China Sea
      { lat: 12.0, lng: 114.0 }, // Spratly Islands
      { lat: 10.0, lng: 109.0 }, // Vietnam coast
      PORTS.HoChiMinh.coordinates,
    ],
  },

  "Jakarta-Melbourne": {
    from: PORTS.Jakarta,
    to: PORTS.Melbourne,
    waypoints: [
      PORTS.Jakarta.coordinates,
      { lat: -8.0, lng: 110.0 }, // Java Sea
      { lat: -12.0, lng: 115.0 }, // Indian Ocean
      { lat: -20.0, lng: 120.0 }, // Off Australian coast
      { lat: -30.0, lng: 130.0 }, // Great Australian Bight
      { lat: -38.0, lng: 140.0 }, // Approaching Melbourne
      PORTS.Melbourne.coordinates,
    ],
  },

  "Valparaiso-Santos": {
    from: PORTS.Valparaiso,
    to: PORTS.Santos,
    waypoints: [
      PORTS.Valparaiso.coordinates,
      { lat: -33.0, lng: -75.0 }, // Pacific Ocean
      { lat: -40.0, lng: -78.0 }, // Southern route
      { lat: -45.0, lng: -70.0 }, // Cape Horn approach
      { lat: -50.0, lng: -65.0 }, // Drake Passage
      { lat: -45.0, lng: -55.0 }, // South Atlantic
      { lat: -35.0, lng: -50.0 }, // Off Argentina
      { lat: -25.0, lng: -47.0 }, // Brazilian coast
      PORTS.Santos.coordinates,
    ],
  },

  "Durban-Mumbai": {
    from: PORTS.Durban,
    to: PORTS.Mumbai,
    waypoints: [
      PORTS.Durban.coordinates,
      { lat: -25.0, lng: 35.0 }, // Mozambique Channel
      { lat: -15.0, lng: 45.0 }, // Off Madagascar
      { lat: -5.0, lng: 55.0 }, // Indian Ocean
      { lat: 5.0, lng: 65.0 }, // Equatorial waters
      { lat: 15.0, lng: 70.0 }, // Arabian Sea
      PORTS.Mumbai.coordinates,
    ],
  },

  "Lagos-Rotterdam": {
    from: PORTS.Lagos,
    to: PORTS.Rotterdam,
    waypoints: [
      PORTS.Lagos.coordinates,
      { lat: 10.0, lng: 0.0 }, // Gulf of Guinea
      { lat: 20.0, lng: -18.0 }, // Off West Africa
      { lat: 35.0, lng: -12.0 }, // Off Morocco
      { lat: 45.0, lng: -8.0 }, // Bay of Biscay
      { lat: 48.0, lng: -5.0 }, // English Channel
      { lat: 50.0, lng: 0.0 }, // North Sea
      PORTS.Rotterdam.coordinates,
    ],
  },

  "Karachi-Dubai": {
    from: PORTS.Karachi,
    to: PORTS.Dubai,
    waypoints: [
      PORTS.Karachi.coordinates,
      { lat: 24.0, lng: 65.0 }, // Arabian Sea
      { lat: 24.0, lng: 60.0 }, // Gulf of Oman
      { lat: 25.0, lng: 57.0 }, // Approaching UAE
      PORTS.Dubai.coordinates,
    ],
  },

  "Marseille-Piraeus": {
    from: PORTS.Marseille,
    to: PORTS.Piraeus,
    waypoints: [
      PORTS.Marseille.coordinates,
      { lat: 42.0, lng: 8.0 }, // Off Corsica
      { lat: 40.0, lng: 12.0 }, // Tyrrhenian Sea
      { lat: 38.0, lng: 15.0 }, // Strait of Messina
      { lat: 37.0, lng: 20.0 }, // Ionian Sea
      PORTS.Piraeus.coordinates,
    ],
  },

  "Manila-Vancouver": {
    from: PORTS.Manila,
    to: PORTS.Vancouver,
    waypoints: [
      PORTS.Manila.coordinates,
      { lat: 20.0, lng: 125.0 }, // Philippine Sea
      { lat: 30.0, lng: 140.0 }, // North Pacific
      { lat: 40.0, lng: 170.0 }, // Mid-Pacific
      { lat: 45.0, lng: -160.0 }, // Eastern Pacific
      { lat: 48.0, lng: -130.0 }, // Off Vancouver Island
      PORTS.Vancouver.coordinates,
    ],
  },

  "Lagos-CapeTown": {
    from: PORTS.Lagos,
    to: PORTS.CapeTown,
    waypoints: [
      PORTS.Lagos.coordinates,
      { lat: 3.0, lng: 7.0 }, // Gulf of Guinea
      { lat: -5.0, lng: 10.0 }, // Off Angola
      { lat: -15.0, lng: 12.0 }, // South Atlantic
      { lat: -25.0, lng: 14.0 }, // Off Namibia
      { lat: -32.0, lng: 16.0 }, // Approaching Cape Town
      PORTS.CapeTown.coordinates,
    ],
  },

  // ... add more routes as needed
};

// Helper function to get all available ports for dropdowns
export const getAvailablePorts = () => {
  return Object.entries(PORTS).map(([key, port]) => ({
    value: key,
    label: port.name,
  }));
};

// Modify the findRoute function to generate more realistic sea routes
export const findRoute = (fromPort, toPort) => {
  // Try direct route
  const directRoute = SHIPPING_ROUTES[`${fromPort}-${toPort}`];
  if (directRoute) {
    return directRoute;
  }

  // Try reverse route
  const reverseRoute = SHIPPING_ROUTES[`${toPort}-${fromPort}`];
  if (reverseRoute) {
    return {
      from: PORTS[fromPort],
      to: PORTS[toPort],
      waypoints: [...reverseRoute.waypoints].reverse(),
    };
  }

  // If no direct or reverse route exists, generate a sea route
  if (PORTS[fromPort] && PORTS[toPort]) {
    const from = PORTS[fromPort].coordinates;
    const to = PORTS[toPort].coordinates;

    // Generate waypoints that follow the coastlines
    const waypoints = [from];

    // More sophisticated routing based on general ocean paths
    if (Math.abs(from.lng - to.lng) > 180) {
      // Pacific Ocean crossing
      waypoints.push(
        { lat: from.lat, lng: from.lng + 15 }, // Exit port area
        { lat: (from.lat + to.lat) / 2, lng: 180 }, // Mid-Pacific (date line)
        { lat: (from.lat + to.lat) / 2, lng: -180 }, // Date line crossing
        { lat: to.lat, lng: to.lng - 15 } // Approach destination
      );
    } else {
      // Determine if route should go around Africa or through Suez
      const isSuezRoute = from.lng > 40 && to.lng > 40;
      if (isSuezRoute) {
        // Route through Suez Canal
        waypoints.push(
          { lat: 12.0, lng: 45.0 }, // Gulf of Aden
          { lat: 27.0, lng: 34.0 }, // Suez Canal
          { lat: 36.0, lng: 3.0 } // Mediterranean
        );
      } else {
        // Add appropriate ocean waypoints based on location
        const midPoint = {
          lat: (from.lat + to.lat) / 2,
          lng: (from.lng + to.lng) / 2,
        };

        // Adjust for major shipping lanes
        if (midPoint.lat > 0) {
          // Northern Hemisphere route
          waypoints.push(
            { lat: from.lat, lng: from.lng + 10 }, // Exit port area
            { lat: midPoint.lat + 5, lng: midPoint.lng }, // Shifted north for currents
            { lat: to.lat, lng: to.lng - 10 } // Approach destination
          );
        } else {
          // Southern Hemisphere route
          waypoints.push(
            { lat: from.lat, lng: from.lng + 10 }, // Exit port area
            { lat: midPoint.lat - 5, lng: midPoint.lng }, // Shifted south for currents
            { lat: to.lat, lng: to.lng - 10 } // Approach destination
          );
        }
      }
    }

    waypoints.push(to);

    return {
      from: PORTS[fromPort],
      to: PORTS[toPort],
      waypoints: waypoints,
    };
  }

  return null;
};
